var _path, _g, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCorrection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 40,
    viewBox: "0 0 35 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.95328 7.19922H17.974C19.3733 7.19922 20.4929 8.35961 20.4929 9.77677V11.1994H18.8896V9.77677C18.8896 9.25255 18.473 8.83983 17.974 8.83983H7.61351V12.4129C7.61351 13.8341 6.48352 14.9904 5.09467 14.9904H1.60324V32.6214C1.60324 33.138 2.01407 33.5584 2.51884 33.5584H3.5624V35.199H2.51884C1.12999 35.199 0 34.0427 0 32.6214V13.2913C0 13.0738 0.0845459 12.8651 0.23485 12.7113L5.38651 7.43954C5.53682 7.28574 5.74077 7.19922 5.95328 7.19922ZM18.8896 12.7994V14.3988H20.4929V12.7994H18.8896ZM18.8896 15.9988H20.4929V32.6214C20.4929 34.0531 19.3589 35.199 17.974 35.199H11.3801V33.5584H17.974C18.4865 33.5584 18.8896 33.1318 18.8896 32.6214V15.9988ZM9.81654 33.5584H8.25278V35.199H9.81654V33.5584ZM6.68924 33.5584V35.199H5.12594V33.5584H6.68924ZM6.01027 12.4126V9.12117L1.87817 13.3496H5.09467C5.59965 13.3496 6.01027 12.9294 6.01027 12.4126Z",
    fill: "#D59B00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.1616,
    y: 16,
    width: 9.38124,
    height: 19.1999,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9189 16H16.8981C16.6856 16 16.4816 16.0865 16.3313 16.2403L11.1797 21.5121C11.0294 21.6659 10.9448 21.8746 10.9448 22.0921V41.4222C10.9448 42.8435 12.0748 43.9998 13.4637 43.9998H28.9189C30.3037 43.9998 31.4377 42.8539 31.4377 41.4222V18.5776C31.4377 17.1604 30.3181 16 28.9189 16ZM16.9551 17.922V21.2134C16.9551 21.7302 16.5445 22.1504 16.0395 22.1504H12.823L16.9551 17.922ZM29.8345 41.4222C29.8345 41.9326 29.4314 42.3592 28.9189 42.3592H13.4637C12.9589 42.3592 12.5481 41.9388 12.5481 41.4222V23.7912H16.0395C17.4283 23.7912 18.5583 22.6349 18.5583 21.2136V17.6406H28.9189C29.4178 17.6406 29.8345 18.0533 29.8345 18.5776V41.4222Z",
    fill: "#D59B00"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3247 2.66329C24.1097 4.5091 25.3209 6.96168 25.62 9.7434L23.9483 8.03277L22.571 9.43726L26.7477 13.7113L30.9244 9.43726L29.5509 8.03277L27.584 10.0456C27.3036 5.93713 25.2991 2.34888 22.3247 0V2.66329Z",
    fill: "#D59B00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.362,
    height: 27.9998,
    fill: "white",
    transform: "translate(7.47119 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCorrection);
export default __webpack_public_path__ + "static/media/icon-correction.5db99bcae89ff744dbcd6c97d8150dc7.svg";
export { ForwardRef as ReactComponent };